export default function sanitizeField(value) {
  if (typeof value !== "string") return value;

  return value
    .replace(/\r?\n|\r/g, " ")
    .replaceAll(",", " ")
    .replaceAll(";", " ")
    .replace(/"/g, '""');
}